import React from 'react';
import styled from 'styled-components'
import Container from 'components/layout/Container';
import Divider from 'components/divider';
import Logo from 'static/ledgerX-logo_white.png';

const LogoWrapper = styled('div')`
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  padding: ${props => props.theme.paddingS} 0;

  img {
    height: ${props => props.theme.logoHeight};
    width: ${props => props.theme.logoWidth};
  }
`

const Header = () => (
  <header>
    <Container>
      <LogoWrapper>
        <img src={Logo} alt="ledgerx.com"/>
      </LogoWrapper>
      <Divider style={{ marginTop: '0' }} />
    </Container>
  </header>
);

export default Header;
